import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import { FDAvatar } from '@facet-wealth/design';

const HouseholdInfoSectionAvatarPicker = ({ resource, size }) => {
  return pick(resource, {
    [fr.relationships.avatar.name]: (<FDAvatar alt={'Avatar'} src={resource.relationship(fr.relationships.avatar.name).link('related').url()} size={size} />),
  }, null);
};

HouseholdInfoSectionAvatarPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};
HouseholdInfoSectionAvatarPicker.defaultProps = {
  size: 'md',
};

export default HouseholdInfoSectionAvatarPicker;
